<template>
  <div class="order-count">
    <el-card class="box-card">
      <template slot="header">
        <div class="card-header">
          <span style="font-size:25px;font-weight:bold;margin:0 10px;">订单统计</span>
        </div>
      </template>

      <!-- 统计概览 -->
      <div class="stats-overview">
        <div style="width:100%;margin-left:0%;">
          <el-row :gutter="10">
            <el-col :span="12">
              <div style="background-color:#e6f1fe;padding-top:10px">
                <div style="display: flex;align-items: center">
                  <span style="font-size:18px;font-weight:bold;padding:0 10px;">总成交</span>
                  <span style="font-size:15px;padding:0 10px;">
                    总成交统计已完成订单数据和金额
                  </span>
                </div>
                <div style="display:flex;">
                  <el-row :gutter="10" style="width:100%">
                    <el-col :span="12">
                      <div style="display: flex;align-items: center;justify-content: center">
                        <el-image :src="dd1" style="max-width:107px;height:60px">
                          <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                        <div class="son-item">
                          <div>订单总数</div>
                          <div>{{ orderTotalNum }}</div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div style="display: flex;align-items: center;justify-content: center">
                        <el-image :src="dd2" style="max-width:107px;height:60px">
                          <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                        <div class="son-item">
                          <div>订单总金额</div>
                          <div>{{ orderTotalMoney.toFixed(2) }}</div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div style="background-color:#e6f1fe;padding-top:10px">
                <span style="font-size:18px;font-weight:bold;padding:0 10px;">今日关键指标</span>
                <div style="display:flex;">
                  <el-row :gutter="10" style="width:100%">
                    <el-col :span="12">
                      <div class="son-item">
                        <div>订单总数</div>
                        <div>{{ orderTodayNum }}</div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="son-item">
                        <div>订单总金额</div>
                        <div>{{ orderTodayMoney }}</div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 订单详情表格 -->
      <div class="table-section">
        <h3 style="margin: 10px 0">经营概况</h3>
        <div class="header-actions">
          <el-radio-group v-model="but_qs" style="margin-left:5px" @change="onQh">
            <el-radio-button label="最近1周"></el-radio-button>
            <el-radio-button label="最近2周"></el-radio-button>
            <el-radio-button label="最近30天"></el-radio-button>
          </el-radio-group>
          <el-date-picker
              v-model="edi_time"
              type="daterange"
              :clearable="false"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="margin-left:10px"
              @change="handleDateChange">
          </el-date-picker>
        </div>
        <el-table :data=orderList class="tab_orderCount" :cell-style="tableYs" border
                  style="width:98%; margin-left:1px;font-size:13px; background:#FFFFFF;margin-top:1px"
                  show-overflow-tooltip
                  ref="multipleTable"
                  :header-cell-style="{ 'height': '30px', 'text-align': 'center', 'background': '#f4f4f4', 'color': '#0dA7C8' }">
          <el-table-column prop="id" label="订单ID" width="180"></el-table-column>
          <el-table-column prop="times" label="下单时间" width="180"></el-table-column>
          <el-table-column prop="money" label="订单金额"></el-table-column>
          <el-table-column prop="status" label="订单状态">
            <template slot-scope="scope">
              <el-tag :type="getOrderStatusType(scope.row.orderStatusName)">
                {{ scope.row.orderStatusName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="客户信息"></el-table-column>
          <!--          <el-table-column label="操作" width="150">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-button size="small" @click="viewOrderDetail(scope.row)">-->
          <!--                查看-->
          <!--              </el-button>-->
          <!--              <el-button size="small" type="primary" @click="editOrder(scope.row)">-->
          <!--                编辑-->
          <!--              </el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>

        <div class="pagination">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 30]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 订单详情对话框 -->
    <el-dialog
        title="订单详情"
        :visible.sync="dialogVisible"
        width="50%">
      <div v-if="currentOrder" class="order-detail">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="日期">{{ currentOrder.orderId }}</el-descriptions-item>
          <el-descriptions-item label="会所空间">{{ currentOrder.orderTime }}</el-descriptions-item>
          <el-descriptions-item label="下单数">{{ currentOrder.amount }}</el-descriptions-item>
          <el-descriptions-item label="下单总金额">{{ getOrderStatusText(currentOrder.status) }}</el-descriptions-item>
          <el-descriptions-item label="支付订单数">{{ currentOrder.customer }}</el-descriptions-item>
          <el-descriptions-item label="实际成交额">{{ currentOrder.remark || '无' }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment/moment";

export default {
  name:'orderCount',
  data() {
    return {
      but_qs:"最近1周",
      edi_time:[
        moment().startOf('isoWeek').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ],
      orderTodayMoney:0,
      orderTodayNum:0,
      orderTotalMoney:0,
      orderTotalNum:0,
      orderList:[],
      page:1,
      pageSize:10,
      total:0,
      dd1:require('@/assets/order/dd1.png'),
      dd2:require('@/assets/order/dd.png'),
      dialogVisible:false,
      currentOrder:null
    };
  },
  methods:{
    onQh() {
      this.page = 1;
      switch (this.but_qs) {
        case '最近1周':
          // 本周周一 -> 当前
          this.edi_time = [
            moment().startOf('isoWeek').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ];
          break;
        case '最近2周':
          // 前一周周一 -> 当前
          this.edi_time = [
            moment().startOf('isoWeek').subtract(7,'days').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ];
          break;
        case '最近30天':
          // 当月1号 -> 当前
          this.edi_time = [
            moment().startOf('month').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ];
          break;
      }
      console.log("***",this.edi_time);
      this.getOrderCountList();
    },
    handleDateChange() {
      this.page = 1;
      this.but_qs = '';
      this.getOrderCountList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getOrderCountList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getOrderCountList();
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    getOrderStatusType(status) {
      switch (status) {
        case "待支付":
          return 'warning';
        case "待发货":
          return 'success';
        case "待收货":
          return 'danger';
        default:
          return '';
      }
    },
    getOrderStatusText(status) {
      switch (status) {
        case 0:
          return '待处理';
        case 1:
          return '已完成';
        case 2:
          return '已取消';
        default:
          return '未知';
      }
    },
    viewOrderDetail(order) {
      this.currentOrder = order;
      this.dialogVisible = true;
    },
    editOrder(order) {
      // 编辑订单逻辑
      console.log('编辑订单:',order);
    },
    getData() {
      // 模拟获取数据
      this.totalOrders = 1234;
      this.totalSales = '¥123,456.78';
      this.pendingOrders = 234;
      this.completedOrders = 1000;
      this.total = 1234;

      // 模拟订单列表数据
      this.orderList = [
        {
          orderId:'ORD202601250001',
          orderTime:'2026-01-25 10:30:00',
          amount:'¥1,234.56',
          status:1,
          customer:'张三',
          remark:'加急处理'
        },
        {
          orderId:'ORD202601250002',
          orderTime:'2026-01-25 09:15:00',
          amount:'¥987.65',
          status:0,
          customer:'李四',
          remark:''
        },
        {
          orderId:'ORD202601240001',
          orderTime:'2026-01-24 16:45:00',
          amount:'¥2,345.67',
          status:1,
          customer:'王五',
          remark:'需要发票'
        },
        {
          orderId:'ORD202601240002',
          orderTime:'2026-01-24 14:20:00',
          amount:'¥567.89',
          status:2,
          customer:'赵六',
          remark:'取消订单'
        },
        {
          orderId:'ORD202601230001',
          orderTime:'2026-01-23 11:05:00',
          amount:'¥1,890.12',
          status:1,
          customer:'孙七',
          remark:''
        }
      ];
    },
    timestampToTime(timestamp) {/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes());
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m;
    },
    init_view(data) {
      let l_d = [];
      for (let i = 0; i < data.length; i++) {
        let d = {
          id:data[i]['id'],
          money:data[i]['money'] / 100, /*金额*/
          userName:"", /*客户名称*/
          orderStatusName:"", /*订单状态*/
          times:this.timestampToTime(data[i]['timestamp'] * 1000)
        };
        if (data[i]['orderStatus']) {
          d['orderStatusName'] = data[i]['orderStatus']['name'];
        }
        if (data[i]['user']['name']) {
          d["userName"] = data[i]['user']['name'];
        } else if (data[i]['user']["nickName"]) {
          d['userName'] = data[i]['user']["nickName"];
        } else if (data[i]['user']["userName"]) {
          d['userName'] = data[i]["userName"];
        }
        l_d.push(d);
      }
      console.log("***",l_d);
      this.orderList = l_d;
    },
    getOrderCountList() {
      const params = {
        page:this.page,
        pageSize:this.pageSize,
        projectId:localStorage.getItem("projectId")
      };
      if (this.but_qs === "最近1周") {
        params['type'] = 1;
      } else if (this.but_qs === "最近2周") {
        params['type'] = 2;
      } else if (this.but_qs === "最近30天") {
        params['type'] = 3;
      } else if (this.edi_time) { /*订单时间*/
        params['fromTime'] = parseInt("" + new Date(this.edi_time[0] + 'T00:00:00').getTime() / 1000);
        params['toTime'] = parseInt(new Date(this.edi_time[1] + 'T00:00:00').getTime() / 1000) + 86400; /*结尾+1天*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getOrderStatisticList,params,headers).then(res => {
        console.log("getOrderStatisticList",res.data.data);
        this.total = res.data.data.total;
        if (res.data.data && res.data.data.list) {
          let li_d = res.data.data.list;
          this.orderTotalNum = li_d.orderTotalNum;
          this.orderTotalMoney = li_d.orderTotalMoney / 100;
          this.orderTodayNum = li_d.orderTodayNum;
          this.orderTodayMoney = li_d.orderTodayMoney / 100;
          if (li_d['orders'] && li_d['orders'].length > 0) {
            this.init_view(li_d['orders']);
          } else {
            this.orderList = [];
          }
        } else {
          this.orderTotalNum = 0;
          this.orderTotalMoney = 0;
          this.orderTodayNum = 0;
          this.orderTodayMoney = 0;
          this.orderList = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取订单统计数据失败");
        }
      });
    }
  },
  mounted() {
    //this.getData();
    this.getOrderCountList();
  }
};
</script>

<style scoped>
.order-count {
  height: 94vh;
  padding: 20px;
  overflow-y: auto;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.stats-overview {
  margin-bottom: 30px;
  display: flex;
  background: #f5f7fa
}

.stat-item {
  background-color: #e6f1fe;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.son-item {
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.stat-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

.chart-section {
  margin-bottom: 30px;
}

.chart-section h3,
.table-section h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
}

.chart-container {
  background-color: #f5f7fa;
  height: 300px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-placeholder {
  color: #909399;
  font-size: 14px;
}

.table-section {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.order-detail {
  padding: 10px 0;
}

.tab_orderCount {
  user-select: text;

  .gutter {
    /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important;
    /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/orderCount.vue